import { PaymentMethodsType } from '@libs/core';
import type { CreditCardsType } from '@libs/core';
import type { IconNames } from '@petsmart-ui/sparky';
import { IconMediaBlock, TextPassage } from '@petsmart-ui/sparky';

import './PaymentMethodPreview.scss';

export type PaymentMethodPreviewProps = {
    type: PaymentMethodsType | string | null;
    cardType?: CreditCardsType | null;
    cardNumbers?: number | string | null;
    cardHolderName?: string;
    cardExpiryDate?: string;
};

export function PaymentMethodPreview({
    type,
    cardType,
    cardNumbers,
    cardHolderName,
    cardExpiryDate,
}: PaymentMethodPreviewProps) {
    let content;
    if (type === PaymentMethodsType.AFTERPAY) {
        content = (
            <IconMediaBlock
                variant="bare"
                iconName="cc-afterpay"
                iconSize="4xl"
            >
                <TextPassage>{PaymentMethodsType.AFTERPAY}</TextPassage>
            </IconMediaBlock>
        );
    }

    if (type === PaymentMethodsType.PAYPAL) {
        content = (
            <IconMediaBlock variant="bare" iconName="cc-paypal" iconSize="4xl">
                <TextPassage>{PaymentMethodsType.PAYPAL}</TextPassage>
            </IconMediaBlock>
        );
    }

    if (type === PaymentMethodsType.CREDITCARD) {
        const cardName = cardType?.replaceAll(' ', '');
        const paymentIconName = (
            cardName ? `cc-${cardName.toLowerCase()}` : 'empty-credit-card'
        ) as IconNames;

        content = (
            <IconMediaBlock variant="bare" iconName={paymentIconName}>
                <TextPassage>
                    <div>{`${cardType || 'N/A'} ending in ${
                        cardNumbers ? String(cardNumbers).slice(-4) : '****'
                    }`}</div>
                    {cardHolderName ? <div>{cardHolderName}</div> : null}
                    {cardExpiryDate ? <div>{cardExpiryDate}</div> : null}
                </TextPassage>
            </IconMediaBlock>
        );
    }

    return (
        <div
            className="payment-method-preview"
            data-testid="payment-method"
            data-cs-mask
        >
            {content}
        </div>
    );
}
